
// Flip the dropdown upward when there isn't room below the trigger.
// Toggles the `.legacy-dropdown--up` modifier; the SCSS in _dropdown.scss (or
// a per-component override, e.g. .portal-breadcrumbs__account-dropdown) reads
// the class and inverts the menu's positioning.
function flipIfNeeded($elem: JQuery<HTMLElement>) {
  const menu = $elem.find('.dropdown__list, .dropdown__menu, [data-legacy-dropdown-menu]').get(0) as HTMLElement | undefined
    ?? ($elem.children('ul, ol').get(0) as HTMLElement | undefined)
  if (!menu) return

  const rect = $elem.get(0)!.getBoundingClientRect()
  const spaceBelow = window.innerHeight - rect.bottom
  const spaceAbove = rect.top

  // Measure the menu height without exposing it: temporarily reveal it
  // off-screen. Skip if already visible (open menu already sized).
  const wasHidden = menu.offsetHeight === 0
  if (wasHidden) {
    menu.style.visibility = 'hidden'
    menu.style.display = 'block'
  }
  const menuHeight = menu.offsetHeight
  if (wasHidden) {
    menu.style.display = ''
    menu.style.visibility = ''
  }

  if (menuHeight > 0 && spaceBelow < menuHeight && spaceAbove >= menuHeight) {
    $elem.addClass('legacy-dropdown--up')
  } else {
    $elem.removeClass('legacy-dropdown--up')
  }
}

export default function menuInit() {
  $('.legacy-dropdown').each((i, elem) => {
    const $elem = $(elem)

    const measureFlip = () => flipIfNeeded($elem)
    $elem.on('mouseenter focusin', measureFlip)

    $elem.children('a').on('click', (evt) => {
      if (!$elem.hasClass('open')) {
        // don't follow the href if the dropdown was closed.
        evt.preventDefault()

        // open the dropdown on a slight delay to prevent accidental doubleclick
        setTimeout(() => {
          $elem.addClass('open')
        }, 100)
      }
    })

    $elem.focusin((evt) => {
      // open the dropdown on tab focusin, but don't do it immediately
      // because if the focus came from user click then the 'click' handler
      // is about to fire.
      if (!$elem.hasClass('open')) {
        setTimeout(() => {
          $elem.addClass('open')
        }, 100)
      }
    })

    // close the dropdown when the focus goes to an element outside of this dropdown.
    // Wait 1 ms for the new element to actually receive focus in firefox.
    $elem.on('focusout', (evt) => {
      setTimeout(() => {
        if ($elem.has(document.activeElement).length == 0) {
          $elem.removeClass('open')
        }
      }, 1)
    })
  })
}
